// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-List-List-module__list";
var _2 = "webpack-components-core-List-List-module__listItem";
export { _1 as "list", _2 as "listItem" }
